import React from "react";
import "../styles/Root.css";

const Resume = () => {
  return (
    <section className="resume" id="resume">
      <div className="container pt-8">
        <div className="about-me-text mt-5 text-center position-relative">
          <h1 className="position-absolute know-text">SUMMARY</h1>
          <h1 className="about-me-txt text-muted">Portfolio</h1>
        </div>
      </div>

      <div className="container pt-5">
        <div className="row pb-sm-3">
          {/* ===================1=============== */}
          <div className="col-md-6">
            <h1 className="text-light pt-4">Education</h1>
            {/* ===============inner-1=========== */}
            <div className="resume-col padding-3">
              <span className="years">2021-2025</span>
              <h2 className="fw-bold text-light mt-4">Computer Science</h2>
              <h4 className="mt-2 uni-name">Osmania University</h4>
              <p
                className="mt-3 fw-bold text-18px"
                style={{ color: "#8f9295" }}
              >
                CSE student pursuing excellence, seeking opportunities to
                contribute and grow.
              </p>
            </div>
            {/* ===============inner-1=========== */}
            <div className="resume-col">
              <span className="years">2020</span>
              <h2 className="fw-bold text-light mt-4">High School Education</h2>
              <h4 className="mt-2 uni-name">SSC Board</h4>
              <p
                className="mt-3 fw-bold text-18px"
                style={{ color: "#8f9295" }}
              >
                High School Graduate (or Completed 12th Grade) from SCC Board
              </p>
            </div>
          </div>
          {/* ===================2=============== */}
          <div className="col-md-6">
            <h1 className="text-light pt-4">My Experience</h1>
            {/* ===============inner-1=========== */}
            <div className="resume-col padding-3">
              <span className="years">2022-Present</span>
              <h2 className="fw-bold text-light mt-4">Jr. Web Developer</h2>
              <h4 className="mt-2 ">
                <a
                  href="https://www.cosmicvent.com/"
                  target="_blank"
                  className="uni-name"
                >
                  Cosmic Vent
                </a>
              </h4>
              <p
                className="mt-3 fw-bold text-18px"
                style={{ color: "#8f9295" }}
              >
                Frontend Developer at CosmicVent: Junior Web Development
                Experience
              </p>
            </div>
            {/* ===============inner-1=========== */}
            <div className="resume-col">
              <span className="years">2021-2025</span>
              <h2 className="fw-bold text-light mt-4">Computer Science</h2>
              <h4 className="mt-2 uni-name">Osmania University</h4>
              <p
                className="mt-3 fw-bold text-18px"
                style={{ color: "#8f9295" }}
              >
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Earum
                necessitatibus velit dolor?
              </p>
            </div>
          </div>
        </div>

        <div className="mySkills mt-lg-5 mt-sm-3">
          <h2 className="text-light mt-4 ">My Skills</h2>
          {/* ================progress-bar========== */}
          <div className="row" style={{ gap: "60px" }}>
            {/* ================1=============== */}
            <div className="col-md-5">
              <div className="progress-top mt-4">
                <h5 className="text-light">Frontend Development</h5>
                <div className="progress">
                  <div
                    className="progress-bar"
                    role="progressbar"
                    aria-label="Basic example"
                    aria-valuenow="0"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style={{ width: "95%" }}
                  ></div>
                </div>
              </div>
              <div className="progress-top mt-5">
                <h5 className="text-light">Web Design</h5>
                <div className="progress">
                  <div
                    className="progress-bar"
                    role="progressbar"
                    aria-label="Basic example"
                    aria-valuenow="0"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style={{ width: "75%" }}
                  ></div>
                </div>
              </div>
              <div className="progress-top mt-5">
                <h5 className="text-light">HTML/CSS</h5>
                <div className="progress">
                  <div
                    className="progress-bar"
                    role="progressbar"
                    aria-label="Basic example"
                    aria-valuenow="0"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style={{ width: "95%" }}
                  ></div>
                </div>
              </div>
            </div>
            {/* ================2=============== */}
            <div className="col-md-5">
              <div className="progress-top mt-4">
                <h5 className="text-light">Bootsrap</h5>
                <div className="progress">
                  <div
                    className="progress-bar"
                    role="progressbar"
                    aria-label="Basic example"
                    aria-valuenow="0"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style={{ width: "90%" }}
                  ></div>
                </div>
              </div>
              <div className="progress-top mt-5">
                <h5 className="text-light">Git / GitHub</h5>
                <div className="progress">
                  <div
                    className="progress-bar"
                    role="progressbar"
                    aria-label="Basic example"
                    aria-valuenow="0"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style={{ width: "75%" }}
                  ></div>
                </div>
              </div>
              <div className="progress-top mt-5">
                <h5 className="text-light">ReactJS</h5>
                <div className="progress">
                  <div
                    className="progress-bar"
                    role="progressbar"
                    aria-label="Basic example"
                    aria-valuenow="0"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style={{ width: "80%" }}
                  ></div>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="download-cv d-flex justify-content-center mt-8">
            <a
              href="resume.pdf"
              download
              className="text-center btn btn-lg btn-outline-secondary"
              style={{ borderRadius: "30px" }}
            >
              <iframe src="resume.pdf">Download</iframe>
            </a>
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default Resume;
